// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wQ0w5"};